'use client'

import { Group, Stack, useMantineColorScheme } from '@mantine/core'

import AccountLogo, { hasAccountLogo } from '@/components/shared/account-logo'
import ShalionLogo from '@/components/shared/shalion-logo'

type AuthLogosProps = {
  account?: string
}

const AuthLogos = (props: AuthLogosProps) => {
  const { account } = props
  const { colorScheme } = useMantineColorScheme()

  let content = <ShalionLogo colorScheme={colorScheme} />

  if (hasAccountLogo(account)) {
    content = (
      <Group
        align='center'
        gap='md'
        justify='space-between'
        style={{
          borderRadius: 'var(--mantine-radius-lg)',
        }}
        w='100%'
      >
        <ShalionLogo colorScheme={colorScheme} size='sm' />
        <AccountLogo account={account} colorScheme={colorScheme} />
      </Group>
    )
  }

  return (
    <Stack
      align='center'
      justify='center'
      gap='xl'
      py='xl'
      px='2xl'
      style={{ borderBottom: '1px solid var(--mantine-color-border-surface)' }}
    >
      {content}
    </Stack>
  )
}

export default AuthLogos
